import { pageMetadataSchema } from '../../schema/pageMetadata.val';
import { s, c, nextAppRouter } from '../../val.config';

export const schema = s.object({
  title: s.string(),
  pageMetadata: pageMetadataSchema,
});

export default c.define(
  '/app/(main)/page.val.ts',
  s.router(nextAppRouter, schema),
  {
    '/': {
      title: 'Spesialister på digital produkt\u00ADutvikling',
      pageMetadata: {
        title: 'Spesialister på digital produktutvikling',
        description:
          'Spesialister på digital produktutvikling og et litt annerledes konsulentselskap i Oslo. Designere og teknologer som lager bra greier for kundene våre og oss selv.',
        image: null,
      },
    },
  }
);
